import {
  getCurrentRole,
  prepareLocation,
} from "components/UserCardList/helpers/userCard";
import { UpdateRecencyBadge } from "components/UserCardList/components/UpdateRecencyBadge";

import HeaderPanel from "./HeaderPanel";
import ProfileImage from "./ProfileImage";
import diceComLogo from "images/dice-com-logo.png";

const Header = ({ hit, ...rest }) => {
  const currentRole = getCurrentRole(hit);

  return (
    <div className="relative w-full min-h-[97px] pt-4">
      <div className="flex flex-wrap gap-4 mt-6 xl:mt-0 h-full">
        <ProfileImage hit={hit} />

        <div className="flex flex-col gap-2 h-full">
          <div className="flex gap-2 flex-row items-start">
            <div className="flex flex-col items-start">
              <p className="font-bold text-2xl whitespace-nowrap">{`${hit.given_name} ${hit.family_name}`}</p>

              <UpdateRecencyBadge
                hit={hit}
                isClickable={!!(hit.lastActivityDate || hit.createdAt)}
              />
            </div>

            {currentRole && (
              <>
                <p className="bg-[#CBD5E1] w-[1px] h-full"></p>
                <p
                  className="text-lg font-normal truncate max-w-[250px] md:max-w-[550px]"
                  title={currentRole}
                >
                  {currentRole}
                </p>
              </>
            )}
          </div>

          <p className="text-base">
            {prepareLocation(hit.location) || hit.locale}{" "}
          </p>

          {hit.talentSource === "dice-integration" && (
            <img
              src={diceComLogo}
              alt="Talent sourced from Dice"
              className="h-4 w-auto self-start"
            />
          )}
        </div>
      </div>

      <div className="talent-card-actions absolute top-0 right-0 -mt-4">
        <HeaderPanel hit={hit} {...rest} />
      </div>
    </div>
  );
};

export default Header;
